import React from 'react';
import Money from "../../../../../../components/Common/Money";

interface Props {
    item: Record<string, any>;
}

const ProductNonConfigurableSubItem = ({item}: Props) => {
    const itemState = item.state;

    const getTitle = () => {
        const name = itemState.name;

        if (itemState.quantity > 1) {
            return `${itemState.quantity}x ${name}`
        }

        return name;
    }

    return (
        <div className="product-non-configurable-sub-item d-flex align-items-center justify-content-between gap-2 mt-1">
            <p>{getTitle()}</p>
            {itemState.total_price > 0 && (
                <p className="price"><Money value={itemState.total_price}/></p>
            )}
        </div>
    )
}

export default ProductNonConfigurableSubItem;